import { Section as CardSection } from '../ExecutiveSummaryCard/types';
import { CardResolver, CardSectionDescriptor } from './cardTypes';

export const buildCardSections = <M extends string>(
    layout: CardSectionDescriptor<M>[],
    resolver: CardResolver<M>,
): CardSection[] => {
    if (!resolver.hasData()) return [];

    return layout
        .map(section => ({
            id: section.id,
            title: section.title,
            items: section.items.flatMap(item => {
                const resolved = resolver[item.metric]();
                return resolved ? [{ id: item.id, label: item.label, value: resolved.value, tooltip: resolved.tooltip }] : [];
            }),
        }))
        .filter(section => section.items.length > 0);
};
